<script setup lang="ts">
import { RouterView } from 'vue-router'
import AppHeader from '@/components/app/AppHeader.vue'
import { OptionsSnackbar } from '@haskoning/vue-component-library'
import { useShowLoadingScreen } from './composables/useLoadingScreen'
import LoadingNotice from './components/app/LoadingNotice.vue'
import { APP_NAME } from './constants'

const showLoadingScreen = useShowLoadingScreen()
</script>

<template>
  <v-app v-if="!showLoadingScreen">
    <AppHeader />
    <v-main>
      <RouterView />
    </v-main>
    <OptionsSnackbar style="z-index: 3000" :excluded-http-methods="['GET', 'OPTIONS', 'PATCH']" />
  </v-app>
  <LoadingNotice v-else :app-name="APP_NAME" />
</template>
<style lang="scss">
// the main file that imports everything related with styles
@use '/src/scss/settings.scss';
</style>
